import React from 'react';
import PropTypes from 'prop-types';

const ChevronRightIcon = (props) => {
  const {
    width, height, fill, className,
  } = props;

  const w = (width) ? width.toString().concat('px') : '14px';
  const h = (height) ? height.toString().concat('px') : '14px';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      className={(className) ? `icon ${className}` : 'icon'}
      viewBox="0 0 14 14"
      width={w}
      height={h}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
                // eslint-disable-next-line max-len
        d="M3.21967 0.219548C3.51256 -0.0733454 3.98744 -0.0733454 4.28033 0.219548L10.2803 6.21955C10.5732 6.51244 10.5732 6.98731 10.2803 7.28021L4.28033 13.2802C3.98744 13.5731 3.51256 13.5731 3.21967 13.2802C2.92678 12.9873 2.92678 12.5124 3.21967 12.2195L8.68934 6.74988L3.21967 1.28021C2.92678 0.987315 2.92678 0.512441 3.21967 0.219548Z"
        fill={(fill) || '#FF5F14'}
      />
    </svg>
  );
};

ChevronRightIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  className: PropTypes.string,
};

export default ChevronRightIcon;
